<template>
  <div>
    <div class="ta_c" style="padding:86px 0 73px;">
      <img src="./../../assets/img/icon_lvsbeauty_pavilion.png" alt="绿瘦美学馆">
    </div>
    <div class="paragraph-body">
      <p>绿瘦美学馆是绿瘦集团旗下的美容美体连锁品牌——曲线科学 以美为先</p>
      <p>绿瘦美学馆继承了绿瘦母品牌十余年的专业体重管理经验，坚持“以科学管理体重”，建立“体形、体重、体雕、体质、体态、体味”6维智能数据化管理体系，同时采用“治未病”的先进理念，从FTO肥胖基因开始剖析，掌握身体肥胖密码，由内而外开启形体管理，让女性即享健康完美曲线。</p>
      <p>时代更迭，消费升级，绿瘦美学馆也在不断地创新和发展。在深谙市场潮流和消费者需求的基础上，绿瘦美学馆精心打造以“形体管理、美颜管理、健康管理”为一体的360°美学体验，帮助广大爱美的女性完成从纤瘦、健康到美丽的升级。</p>
      <div class="paragraph-body-covermap clearfix">
        <img src="http://www.lvshouhotel.com/lvshouhotel/img_meixueguans_beaty.png">
      </div>
    </div>
  </div>
  
</template>
<script>

export default {
  name: "lvshouMeiXueGuan",
  data() {
    return {

    }
  },
  components: {
   
  }
};
</script>

<style lang="less" scoped>
.paragraph-body{
  width: 962px;
  .paragraph-body-covermap {
    padding-top: 26px;
    .fl{
      img{
        width: 100%;
      }
      &:first-child{
        width: 630px;
        margin-right: 12px;
      }
      &:last-child{
        width: 320px;
      }
    }
   
  }
}

</style>

